import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Store__System } from "@talentbait/shared-components";
import logger from "../../utils/LoggerFrontend";
import { withRefluxStore } from "../../Stores";
import CampaignsOverviewStore from "./CampaignsOverviewStore";
import { toZonedTime } from "date-fns-tz";

import Dashboard from "./components/dashboard/Dashboard";
import {
  DashboardSection,
  DashboardTitle,
  HelloMessageContainer,
  HelloMessageEmoji,
  HelloMessageText,
  PageContainer
} from "./CampaignsOverview.styled";
import { useTranslation } from "react-i18next";
import { ActionsCampaignsOverview } from "../../Actions/ActionsCampaignsOverview/ActionsCampaignsOverview";

const CampaignsOverview = ({
  flags,
  //Store
  userProfile,
  user
}) => {
  const { t } = useTranslation();
  const [helloMessage, setHelloMessage] = useState({});

  useEffect(() => {
    if (userProfile?.organizationId && userProfile?.language) {
      ActionsCampaignsOverview.getHelloMessage(userProfile?.language);
    }

    const helloMessageSuccess = ActionsCampaignsOverview.getHelloMessage.completed.listen(
      (result) => {
        logger.log("CampaignsOverview:getHelloMessageSuccess", "called...", {
          result
        });
        const { payload } = result;
        const randomIndex = Math.floor(Math.random() * payload.length);

        setHelloMessage(payload[randomIndex]);
        helloMessageSuccess();
      }
    );

    const helloMessageFailed = ActionsCampaignsOverview.getHelloMessage.failed.listen((error) => {
      logger.log("error:CampaignsOverview:getHelloMessageFailed", "called...", {
        error
      });
      setHelloMessage({});
      helloMessageFailed();
    });
  }, [userProfile]);

  if (!user) {
    return <Redirect to="/login" />;
  }

  const getGreeting = () => {
    const userTimeZone =
      (typeof Intl !== "undefined" && Intl.DateTimeFormat().resolvedOptions().timeZone) || "UTC";

    const currentDate = new Date();
    const zonedDate = toZonedTime(currentDate, userTimeZone);

    const hour = zonedDate.getHours();

    if (hour >= 5 && hour < 12) {
      return t("Good morning, {{name}}", { name: userProfile?.firstname });
    } else if (hour >= 12 && hour < 18) {
      return t("Good afternoon, {{name}}", { name: userProfile?.firstname });
    } else {
      return t("Good evening, {{name}}", { name: userProfile?.firstname });
    }
  };

  return (
    <PageContainer>
      <DashboardSection>
        <DashboardTitle>
          <article>{getGreeting()}</article>
          <HelloMessageContainer>
            <HelloMessageEmoji>{helloMessage?.emoji}</HelloMessageEmoji>
            <HelloMessageText>{helloMessage?.text}</HelloMessageText>
          </HelloMessageContainer>
        </DashboardTitle>
        <Dashboard flags={flags} />
      </DashboardSection>
    </PageContainer>
  );
};

export default withRefluxStore(
  CampaignsOverview,
  [CampaignsOverviewStore, Store__System],
  ["userProfile", "user"]
);
